import axios from 'axios'
// frontend api
const apiClient = () =>
    axios.create({
        baseURL: process.env.NEXT_PUBLIC_API_URL,
    })

// backend api
const pythonBEClient = () =>
    axios.create({
        baseURL: process.env.BACKEND_URL,
        headers: {
            'Content-Type': 'application/json',
        },
    })

const graphApiClient = axios.create({
    baseURL: 'https://graph.microsoft.com/v1.0/me',
    timeout: 30000, // 30 second timeout
})

// Add retry logic for graph API timeout errors
graphApiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { config, response } = error

        // Handle timeout or 504 errors
        if (!response || response.status === 504 || error.code === 'ECONNABORTED') {
            config.__retryCount = config.__retryCount || 0
            if (config.__retryCount < 2) {
                // Retry up to 2 times for timeout errors
                config.__retryCount += 1
                // Increase timeout for retry
                config.timeout = 45000 // 45 seconds for retry
                return graphApiClient(config)
            }
        }

        return Promise.reject(error)
    }
)

export { apiClient, pythonBEClient, graphApiClient }
